<template>
  <div class="content invitation-senior-page">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/overview' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>邀请学长</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <el-button size="small" icon="el-icon-refresh" @click="refresh">刷新</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openTeacherForm()">添加师资</el-button>
      </div>
    </div>

    <el-card class="overview-card" shadow="never">
      <div class="overview-statistic">
        <div class="statistic-list">
          <div v-for="item in statisticItems" :key="item.key" class="statistic-item">
            <span>{{ item.label }}</span>
            <strong :title="statistic[item.key] === undefined ? '暂无统计数据' : ''">{{ statistic[item.key] === undefined ? '--' : statistic[item.key] }}</strong>
          </div>
        </div>
        <div v-if="statisticsUnavailable" class="statistic-empty-tip"><i class="el-icon-info" />统计功能暂未上线，等待后续持续更新</div>
      </div>
      <div class="my-invitation">
        <div class="invite-panel-label"><i class="el-icon-share" />邀请学长</div>
        <div class="invite-link-row">
          <el-button size="mini" type="primary" icon="el-icon-document-copy" :disabled="!inviteReady" @click="copyText(inviteH5Url, '邀请链接已复制')">复制链接</el-button>
          <el-button size="mini" icon="el-icon-picture-outline" :disabled="!inviteReady" @click="openInviteMaterial">二维码/海报</el-button>
        </div>
        <p v-if="!inviteReady" class="invite-tip">当前账号缺少机构或用户参数</p>
      </div>
    </el-card>

    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="card-title">院校专业列表 <span>共 {{ total }} 条</span></div>
        <el-input
          v-model.trim="collegeMajorKeyword"
          class="college-major-search"
          size="small"
          clearable
          prefix-icon="el-icon-search"
          placeholder="输入院校名称、专业代码或名称"
          @input="handleCollegeMajorKeywordInput"
          @keyup.enter.native="searchCollegeMajor"
          @clear="searchCollegeMajor"
        />
      </div>
      <el-table v-loading="listLoading" :data="tableData" border class="college-table" :header-cell-style="headerStyle" :cell-style="cellStyle">
        <el-table-column label="序号" width="70">
          <template slot-scope="scope">{{ serialNumber(scope.$index, pageIndex, pageSize) }}</template>
        </el-table-column>
        <el-table-column prop="college_name" label="院校名称" min-width="190" show-overflow-tooltip />
        <el-table-column label="专业" min-width="250" show-overflow-tooltip>
          <template slot-scope="scope">{{ majorLabel(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="关联师资" min-width="310">
          <template slot-scope="scope">
            <div class="teacher-counts">
              <span v-if="hasCount(scope.row.count_pre_teacher_normal)" class="count-item normal">已入库 <strong>{{ scope.row.count_pre_teacher_normal }}</strong> 人</span>
              <span v-if="hasCount(scope.row.count_pre_teacher_tocheck)" class="count-item checking">审核中 <strong>{{ scope.row.count_pre_teacher_tocheck }}</strong> 人</span>
              <span v-if="hasCount(scope.row.count_pre_teacher_outline)" class="count-item offline">已下线 <strong>{{ scope.row.count_pre_teacher_outline }}</strong> 人</span>
              <span v-if="!hasTeacherCount(scope.row)" class="empty-value">--</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="165">
          <template slot-scope="scope">{{ formatTime(scope.row.create_time) }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="165">
          <template slot-scope="scope">{{ formatTime(scope.row.update_time) }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="110">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="openTeacherDrawer(scope.row)">查看师资</el-link>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty">
            <i class="el-icon-user" />
            <p>暂无相关院校专业</p>
            <el-button size="small" type="primary" plain @click="openTeacherForm()">添加师资</el-button>
          </div>
        </template>
      </el-table>
      <div class="pagination-wrap">
        <span>第 {{ pageIndex }} / {{ Math.max(Math.ceil(total / pageSize), 1) }} 页</span>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <el-drawer
      :title="teacherDrawerTitle"
      :visible.sync="teacherDrawerVisible"
      size="88%"
      append-to-body
      @closed="resetTeacherDrawer"
    >
      <div class="teacher-drawer-content">
        <div class="drawer-toolbar">
          <span>共 {{ teacherTotal }} 位学长</span>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openTeacherForm(null, currentCollegeMajor)">添加师资</el-button>
        </div>
        <el-table v-loading="teacherLoading" :data="teacherData" border stripe size="small" :header-cell-style="headerStyle" :cell-style="cellStyle">
          <el-table-column label="序号" width="64">
            <template slot-scope="scope">{{ serialNumber(scope.$index, teacherPageIndex, teacherPageSize) }}</template>
          </el-table-column>
          <el-table-column label="学长信息" min-width="170">
            <template slot-scope="scope">
              <div class="teacher-main">
                <strong>{{ valueOrEmpty(scope.row.teacher_name) }}</strong>
                <el-tag size="mini" :type="teacherStatus(scope.row).type">{{ teacherStatus(scope.row).label }}</el-tag>
                <small>排序：{{ valueOrEmpty(scope.row.pre_college_major_rank) }}</small>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="录取信息" min-width="260">
            <template slot-scope="scope">
              <div class="cell-lines">
                <p><span>年份</span>{{ valueOrEmpty(scope.row.teacher_apply_year) }}</p>
                <p><span>初试</span>{{ scoreLabel(scope.row.teacher_first_exam_score) }}</p>
                <p><span>方向</span>{{ directionLabel(scope.row) }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系方式" min-width="230">
            <template slot-scope="scope">
              <div v-if="hasContact(scope.row)" class="contact-lines">
                <div v-if="scope.row.teacher_phone" class="contact-line"><span>手机</span><em>{{ scope.row.teacher_phone }}</em><el-button type="text" icon="el-icon-document-copy" @click="copyContact(scope.row.teacher_phone, '手机号')">复制</el-button></div>
                <div v-if="scope.row.teacher_wechat" class="contact-line"><span>微信</span><em>{{ scope.row.teacher_wechat }}</em><el-button type="text" icon="el-icon-document-copy" @click="copyContact(scope.row.teacher_wechat, '微信号')">复制</el-button></div>
                <div v-if="scope.row.teacher_qq" class="contact-line"><span>QQ</span><em>{{ scope.row.teacher_qq }}</em><el-button type="text" icon="el-icon-document-copy" @click="copyContact(scope.row.teacher_qq, 'QQ号')">复制</el-button></div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="备注信息" min-width="260">
            <template slot-scope="scope">
              <div :class="['teacher-remark', { expanded: expandedRemarkIds.indexOf(scope.row.id) > -1 }]">
                {{ teacherAdvantage(scope.row) }}
              </div>
              <el-link
                v-if="teacherAdvantage(scope.row) !== '--' && teacherAdvantage(scope.row).length > 45"
                type="primary"
                :underline="false"
                class="remark-toggle"
                @click="toggleRemark(scope.row.id)"
              >{{ expandedRemarkIds.indexOf(scope.row.id) > -1 ? '收起' : '展开' }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="使用情况" width="150">
            <template slot-scope="scope">
              <div class="cell-lines compact">
                <p><span>采用</span>{{ countValue(scope.row.pre_check_access_count) }} 次</p>
                <p><span>驳回</span>{{ countValue(scope.row.pre_check_refuse_count) }} 次</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="125">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="openTeacherForm(scope.row, currentCollegeMajor)">修改</el-link>
              <el-button type="text" class="delete-action" :loading="deletingTeacherId === scope.row.id" @click="confirmDeleteTeacher(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="table-empty">
              <p>该院校专业暂无师资</p>
              <el-button size="small" type="primary" plain @click="openTeacherForm(null, currentCollegeMajor)">添加师资</el-button>
            </div>
          </template>
        </el-table>
        <div class="pagination-wrap drawer-pagination">
          <span>共 {{ teacherTotal }} 位学长</span>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            :current-page="teacherPageIndex"
            :page-sizes="[10, 20, 50]"
            :page-size="teacherPageSize"
            :total="teacherTotal"
            @size-change="handleTeacherSizeChange"
            @current-change="handleTeacherCurrentChange"
          />
        </div>
      </div>
    </el-drawer>

    <el-dialog title="邀请二维码及海报" :visible.sync="inviteMaterialVisible" width="560px" append-to-body>
      <div class="material-actions">
        <el-button size="small" :type="activeMaterial === 'qrcode' ? 'primary' : ''" :loading="qrCodeLoading" @click="showQrCode">邀请二维码</el-button>
        <el-button size="small" :type="activeMaterial === 'poster' ? 'primary' : ''" :loading="posterLoading" @click="showPoster">邀请海报</el-button>
      </div>
      <div v-if="activeMaterial === 'qrcode'" v-loading="qrCodeLoading" class="qr-material">
        <img v-if="qrCodeSource" :src="qrCodeSource" class="invite-qrcode" alt="邀请学长二维码" />
        <div v-else-if="!qrCodeLoading" class="material-placeholder"><i class="el-icon-picture-outline" /><p>二维码暂未生成</p></div>
      </div>
      <div v-else-if="activeMaterial === 'poster'" v-loading="posterLoading" class="poster-material">
        <img v-if="posterSource" :src="posterSource" class="invite-poster" alt="邀请学长海报" />
        <div v-else-if="!posterLoading" class="material-placeholder"><i class="el-icon-picture-outline" /><p>海报暂未生成</p></div>
      </div>
      <div v-else class="material-placeholder initial"><i class="el-icon-share" /><p>选择需要查看的邀请资料</p></div>
      <div ref="inviteQrRenderer" class="qrcode-renderer" aria-hidden="true" />
      <span slot="footer">
        <el-button size="small" @click="inviteMaterialVisible = false">关闭</el-button>
        <a v-if="activeMaterial === 'qrcode' && qrCodeSource" :href="qrCodeSource" :download="`邀请学长二维码-${inviteFileSuffix}.png`" class="el-button el-button--small el-button--primary">下载二维码</a>
        <a v-if="activeMaterial === 'poster' && posterSource" :href="posterSource" :download="`邀请学长海报-${inviteFileSuffix}.png`" class="el-button el-button--small el-button--primary">下载海报</a>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="teacherFormVisible"
      width="1060px"
      top="5vh"
      custom-class="teacher-form-dialog"
      append-to-body
      :close-on-click-modal="false"
      :before-close="beforeCloseTeacherForm"
      @closed="resetTeacherForm"
    >
      <div slot="title" class="teacher-dialog-heading">
        <div class="teacher-dialog-title-row">
          <strong>{{ teacherFormTitle }}</strong>
          <el-tag v-if="editingTeacher" size="mini" :type="teacherStatus(editingTeacher).type">{{ teacherStatus(editingTeacher).label }}</el-tag>
        </div>
        <div class="teacher-dialog-context" :title="teacherFormContext">
          <i class="el-icon-school" />{{ teacherFormContext }}
        </div>
      </div>
      <el-form ref="teacherForm" :model="teacherForm" :rules="teacherRules" label-position="top" size="small" class="teacher-form">
        <div class="teacher-form-layout">
          <main class="teacher-form-main">
            <section class="form-section-card">
              <div class="form-section-heading"><span>基本信息</span><small>师资身份和录取情况</small></div>
              <div class="form-grid">
                <el-form-item label="姓名" prop="teacher_name"><el-input ref="teacherNameInput" v-model.trim="teacherForm.teacher_name" placeholder="请输入真实姓名" /></el-form-item>
                <el-form-item label="性别" prop="pre_teacher_gender"><el-radio-group v-model="teacherForm.pre_teacher_gender"><el-radio :label="1">男</el-radio><el-radio :label="2">女</el-radio></el-radio-group></el-form-item>
                <el-form-item label="录取年份" prop="teacher_apply_year"><el-select v-model="teacherForm.teacher_apply_year" placeholder="请选择录取年份"><el-option v-for="year in applyYears" :key="year" :label="year + '年'" :value="year" /></el-select></el-form-item>
                <el-form-item label="录取类型" prop="recruit_type"><el-select v-model="teacherForm.recruit_type" placeholder="请选择录取类型"><el-option v-for="item in recruitTypeOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item>
              </div>
            </section>

            <section class="form-section-card admission-section">
              <div class="form-section-heading"><span>录取信息</span><small>请按照院校、专业、学院、方向依次选择</small></div>
              <div class="form-grid">
                <el-form-item label="录取院校" prop="pre_apply_college_code"><el-select v-model="teacherForm.pre_apply_college_code" filterable clearable placeholder="请选择录取院校" @change="applyCollegeChange"><el-option v-for="item in collegeOptions" :key="item.code" :label="item.name" :value="item.code" /></el-select></el-form-item>
                <el-form-item label="录取专业" prop="pre_apply_major_code"><el-select v-model="teacherForm.pre_apply_major_code" filterable clearable :loading="applyMajorLoading" :placeholder="teacherForm.pre_apply_college_code ? '请选择录取专业' : '请先选择录取院校'" :disabled="!teacherForm.pre_apply_college_code" @change="applyMajorChange"><el-option v-for="item in applyMajorOptions" :key="item.code" :label="majorOptionLabel(item)" :value="item.code" /></el-select></el-form-item>
                <el-form-item label="录取学院" prop="pre_apply_academy_code"><el-select v-model="teacherForm.pre_apply_academy_code" filterable clearable :loading="majorDetailLoading" :placeholder="teacherForm.pre_apply_major_code ? '请选择录取学院' : '请先选择录取专业'" :disabled="!teacherForm.pre_apply_major_code" @change="academyChange"><el-option v-for="item in academyOptions" :key="item.academy_code" :label="item.academy_name" :value="item.academy_code" /></el-select></el-form-item>
                <el-form-item label="录取方向" prop="pre_apply_direction_code"><el-select v-model="teacherForm.pre_apply_direction_code" filterable clearable :placeholder="teacherForm.pre_apply_academy_code ? '请选择录取方向' : '请先选择录取学院'" :disabled="!teacherForm.pre_apply_academy_code" @change="directionChange"><el-option v-for="item in directionOptions" :key="item.direction_code" :label="directionOptionLabel(item)" :value="item.direction_code" /></el-select></el-form-item>
                <el-form-item label="考试科目" prop="pre_first_subject_codes" class="full"><el-select v-model="teacherForm.pre_first_subject_codes" multiple filterable clearable :loading="subjectLoading" :placeholder="teacherForm.pre_apply_academy_code ? '请选择考试科目' : '请先选择录取学院'" :disabled="!teacherForm.pre_apply_academy_code" @change="subjectChange"><el-option v-for="item in subjectOptions" :key="item.subject_code" :label="subjectOptionLabel(item)" :value="item.subject_code" /></el-select></el-form-item>
              </div>
            </section>

            <section class="form-section-card optional-section">
              <div class="form-section-heading"><span>本科信息</span><el-tag size="mini" type="info">选填</el-tag></div>
              <div class="form-grid">
                <el-form-item label="本科院校"><el-select v-model="teacherForm.regular_college_code" filterable clearable placeholder="请选择本科院校" @change="regularCollegeChange"><el-option v-for="item in collegeOptions" :key="item.code" :label="item.name" :value="item.code" /></el-select></el-form-item>
                <el-form-item label="本科专业"><el-select v-model="teacherForm.regular_major_code" filterable clearable :loading="regularMajorLoading" :placeholder="teacherForm.regular_college_code ? '请选择本科专业' : '请先选择本科院校'" :disabled="!teacherForm.regular_college_code" @change="regularMajorChange"><el-option v-for="item in regularMajorOptions" :key="item.code" :label="majorOptionLabel(item)" :value="item.code" /></el-select></el-form-item>
              </div>
            </section>

            <section class="form-section-card advantage-section">
              <div class="form-section-heading"><span>个人辅导优势</span><el-tag size="mini" type="info">选填</el-tag></div>
              <el-form-item class="no-bottom-margin"><el-input v-model="teacherForm.tutor_avantage" type="textarea" :rows="4" maxlength="100" show-word-limit placeholder="例如：擅长复试指导、专业课答疑、备考规划等" /></el-form-item>
            </section>
          </main>

          <aside class="teacher-form-aside">
            <section class="form-section-card contact-section">
              <div class="form-section-heading"><span>联系方式</span><small>手机或微信至少填写一项</small></div>
              <el-form-item label="手机号" prop="teacher_phone"><el-input v-model.trim="teacherForm.teacher_phone" maxlength="11" placeholder="请输入11位手机号" prefix-icon="el-icon-mobile-phone" /></el-form-item>
              <el-form-item label="微信号"><el-input v-model.trim="teacherForm.teacher_wechat" placeholder="请输入老师微信号" prefix-icon="el-icon-chat-dot-round" @blur="validateContactField" /></el-form-item>
              <el-form-item label="QQ号"><el-input v-model.trim="teacherForm.teacher_qq" placeholder="选填老师QQ号" prefix-icon="el-icon-message" /></el-form-item>
            </section>

            <section class="form-section-card identity-section">
              <div class="form-section-heading"><span>身份证明</span><el-tag size="mini" type="info">选填</el-tag></div>
              <el-upload
                class="identity-uploader"
                :action="identityUploadUrl"
                list-type="picture-card"
                accept="image/*"
                multiple
                :limit="9"
                :file-list="identityFileList"
                :before-upload="beforeIdentityUpload"
                :on-change="identityFileChange"
                :on-preview="previewIdentityImage"
                :on-success="identityUploadSuccess"
                :on-error="identityUploadError"
                :on-remove="identityFileRemove"
                :on-exceed="identityUploadExceed"
              >
                <i class="el-icon-plus" />
              </el-upload>
              <div class="form-help">最多9张，单张不超过10MB。支持研招网截图、录取通知书、研究生证或校园卡。</div>
            </section>
          </aside>
        </div>
      </el-form>
      <div slot="footer" class="teacher-form-footer">
        <div class="form-completion">
          <span>必填完成</span>
          <el-progress :percentage="teacherFormCompletionPercent" :show-text="false" :stroke-width="6" />
          <strong>{{ teacherFormCompletedCount }}/{{ teacherFormRequiredTotal }}</strong>
        </div>
        <div>
          <el-button size="small" :disabled="teacherSubmitLoading" @click="requestCloseTeacherForm">取消</el-button>
          <el-button size="small" type="primary" :loading="teacherSubmitLoading" @click="validateTeacherForm">{{ editingTeacher ? '保存修改' : '确认提交' }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="查看证明图片" :visible.sync="identityPreviewVisible" width="560px" append-to-body custom-class="identity-preview-dialog">
      <img :src="identityPreviewUrl" class="identity-preview-image" alt="师资身份证明" />
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { createPreTeacherByHandle, followCollegeMajorList, majorInfo, majorlist, preTeacherList, subjectlist, updatePreTeacher, updatePreTeacherStatus } from '@/request/api'

const INVITE_SENIOR_H5_URL = 'https://share.yanshizi.com/#/subPack/myAttention/invitateTeachersForm'
const INVITE_SENIOR_POSTER_URL = 'https://upload.kaoyanbox.net/b7200d9216af3798bbe486aec68fd144.png'
const IDENTITY_UPLOAD_URL = 'https://api.kaoyanbox.com/api/v1/upload/image'

const EMPTY_TEACHER_FORM = () => ({
  id: '', teacher_name: '', pre_teacher_gender: '', regular_college_code: '', regular_college_name: '', regular_major_code: '', regular_major_name: '', tutor_avantage: '',
  teacher_apply_year: '', recruit_type: '', pre_apply_college_code: '', pre_apply_college_name: '', pre_apply_major_code: '', pre_apply_major_name: '', pre_apply_academy_code: '', pre_apply_academy_name: '', pre_apply_direction_code: '', pre_apply_direction_name: '', pre_first_subject_codes: [], pre_first_subject_names: '',
  teacher_phone: '', teacher_wechat: '', teacher_qq: '',
})

export default {
  name: 'InvitationSenior',
  data() {
    const contactValidator = (rule, value, callback) => {
      if (!this.teacherForm.teacher_phone && !this.teacherForm.teacher_wechat) callback(new Error('手机号、微信号至少填写一项'))
      else if (this.teacherForm.teacher_phone && !/^1[3-9]\d{9}$/.test(this.teacherForm.teacher_phone)) callback(new Error('请输入正确的11位手机号'))
      else callback()
    }
    return {
      statistic: {},
      statisticItems: [
        { key: 'today', label: '今日新增学长' }, { key: 'month', label: '本月新增学长' }, { key: 'total', label: '累计邀请学长' },
        { key: 'normal', label: '已入库学长' }, { key: 'checking', label: '审核中学长' }, { key: 'offline', label: '已下线学长' },
      ],
      tableData: [], total: 0, pageIndex: 1, pageSize: 10, listLoading: false, collegeMajorKeyword: '', collegeMajorSearchTimer: null, collegeMajorRequestId: 0,
      teacherDrawerVisible: false, currentCollegeMajor: {}, teacherData: [], teacherTotal: 0, teacherPageIndex: 1, teacherPageSize: 10, teacherLoading: false, expandedRemarkIds: [],
      inviteMaterialVisible: false, activeMaterial: '', qrCodeSource: '', qrCodeLoading: false, posterSource: '', posterLoading: false,
      teacherFormVisible: false, editingTeacher: null, teacherForm: EMPTY_TEACHER_FORM(), teacherSubmitLoading: false, teacherFormInitialSnapshot: '', teacherFormRequiredTotal: 10, previousApplyCollegeCode: '', previousApplyMajorCode: '', deletingTeacherId: null, identityUploadUrl: IDENTITY_UPLOAD_URL, identityFileList: [], identityPreviewVisible: false, identityPreviewUrl: '', collegeOptions: [], regularMajorOptions: [], applyMajorOptions: [], academyOptions: [], directionOptions: [], subjectOptions: [], regularMajorLoading: false, applyMajorLoading: false, majorDetailLoading: false, subjectLoading: false,
      applyYears: ['2024', '2025', '2026', '2027', '2028', '2029', '2030'],
      recruitTypeOptions: [{ label: '未知', value: 0 }, { label: '一志愿', value: 1 }, { label: '调剂', value: 2 }],
      teacherRules: {
        teacher_name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        pre_teacher_gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        teacher_apply_year: [{ required: true, message: '请选择录取年份', trigger: 'change' }],
        recruit_type: [{ required: true, message: '请选择录取类型', trigger: 'change' }],
        pre_apply_college_code: [{ required: true, message: '请选择录取院校', trigger: 'change' }],
        pre_apply_major_code: [{ required: true, message: '请选择录取专业', trigger: 'change' }],
        pre_apply_academy_code: [{ required: true, message: '请选择录取学院', trigger: 'change' }],
        pre_apply_direction_code: [{ required: true, message: '请选择录取方向', trigger: 'change' }],
        pre_first_subject_codes: [{ type: 'array', required: true, message: '请选择考试科目', trigger: 'change' }],
        teacher_phone: [{ validator: contactValidator, trigger: 'blur' }],
      },
      headerStyle: { textAlign: 'center', color: '#606266', background: '#f5f7fa', fontWeight: '500' },
      cellStyle: { textAlign: 'center', fontSize: '13px' },
    }
  },
  computed: {
    companyUser() { try { return JSON.parse(localStorage.getItem('companyUser') || '{}') } catch (error) { return {} } },
    inviteCode() { return this.companyUser.crm_invitecode || '' },
    companyId() { return localStorage.getItem('cid') || '' },
    userId() { return this.companyUser.id || localStorage.getItem('userId') || '' },
    inviteReady() { return !!(this.companyId && this.userId) },
    inviteH5Url() { return `${INVITE_SENIOR_H5_URL}?cid=${encodeURIComponent(this.companyId)}&uid=${encodeURIComponent(this.userId)}` },
    inviteFileSuffix() { return this.inviteCode || `${this.companyId}-${this.userId}` },
    statisticsUnavailable() { return this.statisticItems.every((item) => this.statistic[item.key] === undefined || this.statistic[item.key] === null) },
    teacherDrawerTitle() {
      if (!this.currentCollegeMajor.college_name) return '师资列表'
      return `师资列表｜${this.currentCollegeMajor.college_name} · ${this.majorLabel(this.currentCollegeMajor)}`
    },
    teacherFormTitle() { return this.editingTeacher ? `修改师资${this.teacherForm.teacher_name ? ` · ${this.teacherForm.teacher_name}` : ''}` : '添加师资' },
    teacherFormContext() {
      const collegeName = this.teacherForm.pre_apply_college_name
      const majorName = this.teacherForm.pre_apply_major_name
      const majorCode = this.teacherForm.pre_apply_major_code
      if (!collegeName && !majorName) return '暂未选择录取院校专业'
      return [collegeName, majorName ? `${majorCode ? `(${majorCode}) ` : ''}${majorName}` : ''].filter(Boolean).join(' · ')
    },
    teacherFormCompletedCount() {
      const form = this.teacherForm
      return [
        !!form.teacher_name,
        form.pre_teacher_gender === 1 || form.pre_teacher_gender === 2,
        !!form.teacher_apply_year,
        form.recruit_type === 0 || !!form.recruit_type,
        !!form.pre_apply_college_code,
        !!form.pre_apply_major_code,
        !!form.pre_apply_academy_code,
        !!form.pre_apply_direction_code,
        Array.isArray(form.pre_first_subject_codes) && form.pre_first_subject_codes.length > 0,
        !!(form.teacher_phone || form.teacher_wechat),
      ].filter(Boolean).length
    },
    teacherFormCompletionPercent() { return Math.round((this.teacherFormCompletedCount / this.teacherFormRequiredTotal) * 100) },
  },
  created() {
    this.$store.dispatch('getAllColleges')
    this.refresh()
  },
  beforeDestroy() {
    if (this.collegeMajorSearchTimer) clearTimeout(this.collegeMajorSearchTimer)
  },
  watch: {
    '$store.state.collegeList': {
      immediate: true,
      handler(value) { this.collegeOptions = value || [] },
    },
  },
  methods: {
    async refresh() {
      await this.getCollegeMajorList()
      if (this.teacherDrawerVisible) await this.getTeacherList()
    },
    async getCollegeMajorList(resetPage) {
      if (resetPage) this.pageIndex = 1
      const requestId = ++this.collegeMajorRequestId
      this.listLoading = true
      try {
        const params = { pageIndex: this.pageIndex, pageSize: this.pageSize }
        if (this.collegeMajorKeyword) params.college_major_keyword = this.collegeMajorKeyword
        const res = await followCollegeMajorList(params)
        if (requestId === this.collegeMajorRequestId && res.code === 0) {
          this.tableData = (res.data && res.data.list) || []
          this.total = (res.data && res.data.count) || 0
          this.pageIndex = (res.data && res.data.pageIndex) || this.pageIndex
          this.pageSize = (res.data && res.data.pageSize) || this.pageSize
        }
      } catch (error) {
        if (requestId === this.collegeMajorRequestId) {
          this.tableData = []
          this.total = 0
        }
      } finally {
        if (requestId === this.collegeMajorRequestId) this.listLoading = false
      }
    },
    handleSizeChange(size) { this.pageSize = size; this.getCollegeMajorList(true) },
    handleCurrentChange(page) { this.pageIndex = page; this.getCollegeMajorList() },
    handleCollegeMajorKeywordInput() {
      if (this.collegeMajorSearchTimer) clearTimeout(this.collegeMajorSearchTimer)
      this.collegeMajorSearchTimer = setTimeout(() => this.searchCollegeMajor(), 350)
    },
    searchCollegeMajor() {
      if (this.collegeMajorSearchTimer) clearTimeout(this.collegeMajorSearchTimer)
      this.collegeMajorSearchTimer = null
      this.getCollegeMajorList(true)
    },
    openTeacherDrawer(row) {
      this.currentCollegeMajor = Object.assign({}, row)
      this.teacherPageIndex = 1
      this.teacherDrawerVisible = true
      this.getTeacherList()
    },
    async getTeacherList() {
      if (!this.currentCollegeMajor.college_code || !this.currentCollegeMajor.major_code) return
      this.teacherLoading = true
      try {
        const res = await preTeacherList({
          pre_apply_college_code: this.currentCollegeMajor.college_code,
          pre_apply_major_code: this.currentCollegeMajor.major_code,
          pageIndex: this.teacherPageIndex,
          pageSize: this.teacherPageSize,
        })
        if (res.code === 0) {
          this.teacherData = (res.data && res.data.list) || []
          this.teacherTotal = (res.data && res.data.count) || 0
          this.teacherPageIndex = (res.data && res.data.pageIndex) || this.teacherPageIndex
          this.teacherPageSize = (res.data && res.data.pageSize) || this.teacherPageSize
        }
      } catch (error) {
        this.teacherData = []
        this.teacherTotal = 0
      } finally { this.teacherLoading = false }
    },
    handleTeacherSizeChange(size) { this.teacherPageSize = size; this.teacherPageIndex = 1; this.getTeacherList() },
    handleTeacherCurrentChange(page) { this.teacherPageIndex = page; this.getTeacherList() },
    resetTeacherDrawer() { this.currentCollegeMajor = {}; this.teacherData = []; this.teacherTotal = 0; this.expandedRemarkIds = [] },
    async openInviteMaterial() {
      if (!this.inviteReady) return
      this.activeMaterial = 'qrcode'
      this.qrCodeSource = ''
      this.posterSource = ''
      this.inviteMaterialVisible = true
      await this.$nextTick()
      this.showQrCode()
    },
    async showQrCode() {
      this.activeMaterial = 'qrcode'
      if (this.qrCodeLoading || this.qrCodeSource) return
      this.qrCodeLoading = true
      try {
        this.qrCodeSource = await this.createOrdinaryQrCode(this.inviteH5Url)
      } catch (error) {
        this.qrCodeSource = ''
        this.$message.error((error && error.message) || '二维码生成失败，请稍后重试')
      } finally { this.qrCodeLoading = false }
    },
    async showPoster() {
      this.activeMaterial = 'poster'
      if (this.posterLoading || this.posterSource) return
      this.posterLoading = true
      try {
        if (!this.qrCodeSource) this.qrCodeSource = await this.createOrdinaryQrCode(this.inviteH5Url)
        this.posterSource = await this.createInvitePoster(this.qrCodeSource)
      } catch (error) {
        this.posterSource = ''
        this.$message.error((error && error.message) || '海报生成失败，请稍后重试')
      } finally { this.posterLoading = false }
    },
    createOrdinaryQrCode(value) {
      return new Promise((resolve, reject) => {
        this.$nextTick(() => {
          try {
            const target = this.$refs.inviteQrRenderer
            if (!target) throw new Error('二维码容器加载失败')
            target.innerHTML = ''
            new QRCode(target, { text: value, width: 320, height: 320, colorDark: '#000000', colorLight: '#ffffff', correctLevel: QRCode.CorrectLevel.H })
            const canvas = target.querySelector('canvas')
            const image = target.querySelector('img')
            let source = image && image.src
            if (canvas) {
              const margin = 12
              const output = document.createElement('canvas')
              output.width = canvas.width + (margin * 2)
              output.height = canvas.height + (margin * 2)
              const context = output.getContext('2d')
              context.fillStyle = '#ffffff'
              context.fillRect(0, 0, output.width, output.height)
              context.drawImage(canvas, margin, margin)
              source = output.toDataURL('image/png')
            }
            if (!source) throw new Error('二维码图片生成失败')
            resolve(source)
          } catch (error) { reject(error) }
        })
      })
    },
    loadImage(source) {
      return new Promise((resolve, reject) => {
        const image = new Image()
        if (/^https?:\/\//.test(source)) image.crossOrigin = 'anonymous'
        image.onload = () => resolve(image)
        image.onerror = () => reject(new Error('海报模板加载失败'))
        image.src = source
      })
    },
    async createInvitePoster(qrSource) {
      const [background, qrCode] = await Promise.all([this.loadImage(INVITE_SENIOR_POSTER_URL), this.loadImage(qrSource)])
      const canvas = document.createElement('canvas')
      canvas.width = background.naturalWidth || background.width
      canvas.height = background.naturalHeight || background.height
      const context = canvas.getContext('2d')
      if (!context) throw new Error('当前浏览器不支持生成海报')
      context.drawImage(background, 0, 0, canvas.width, canvas.height)
      // 沿用参考实现基于 686×1188 原图标定的二维码位置和尺寸。
      const qrX = (286 / 686) * canvas.width
      const qrY = (400 / 686) * canvas.width
      const qrSize = (140 / 686) * canvas.width
      context.drawImage(qrCode, qrX, qrY, qrSize, qrSize)
      return canvas.toDataURL('image/png')
    },
    copyText(value, message) { this.$copyText(value).then(() => this.$message.success(message)) },
    copyContact(value, label) { this.copyText(String(value), `${label}已复制`) },
    async openTeacherForm(teacher, collegeMajor) {
      this.editingTeacher = teacher || null
      this.teacherForm = Object.assign(EMPTY_TEACHER_FORM(), teacher || {})
      if (this.teacherForm.pre_teacher_gender !== '') this.teacherForm.pre_teacher_gender = Number(this.teacherForm.pre_teacher_gender)
      if (this.teacherForm.recruit_type !== '') this.teacherForm.recruit_type = Number(this.teacherForm.recruit_type)
      if (this.teacherForm.teacher_apply_year !== '') this.teacherForm.teacher_apply_year = String(this.teacherForm.teacher_apply_year)
      this.teacherForm.pre_first_subject_codes = this.splitValues(teacher && teacher.pre_first_subject_codes)
      if (collegeMajor && !teacher) {
        this.teacherForm.pre_apply_college_code = collegeMajor.college_code || ''
        this.teacherForm.pre_apply_college_name = collegeMajor.college_name || ''
        this.teacherForm.pre_apply_major_code = collegeMajor.major_code || ''
        this.teacherForm.pre_apply_major_name = collegeMajor.major_name || ''
      }
      this.identityFileList = this.imageFiles(teacher && teacher.identity_certify_img)
      this.previousApplyCollegeCode = this.teacherForm.pre_apply_college_code
      this.previousApplyMajorCode = this.teacherForm.pre_apply_major_code
      this.teacherFormInitialSnapshot = this.teacherFormSnapshot()
      this.teacherFormVisible = true
      this.$nextTick(() => {
        if (this.$refs.teacherNameInput) this.$refs.teacherNameInput.focus()
      })
      await this.prepareFormOptions()
    },
    async prepareFormOptions() {
      if (this.teacherForm.regular_college_code) await this.fetchMajorOptions('regular')
      if (this.teacherForm.pre_apply_college_code) await this.fetchMajorOptions('apply')
      if (this.teacherForm.pre_apply_college_code && this.teacherForm.pre_apply_major_code) await this.fetchMajorDetail()
      if (this.teacherForm.pre_apply_academy_code) await this.fetchSubjectOptions()
    },
    resetTeacherForm() {
      this.editingTeacher = null
      this.teacherForm = EMPTY_TEACHER_FORM()
      this.teacherSubmitLoading = false
      this.teacherFormInitialSnapshot = ''
      this.previousApplyCollegeCode = ''
      this.previousApplyMajorCode = ''
      this.identityFileList = []
      this.regularMajorOptions = []
      this.applyMajorOptions = []
      this.academyOptions = []
      this.directionOptions = []
      this.subjectOptions = []
      this.regularMajorLoading = false
      this.applyMajorLoading = false
      this.majorDetailLoading = false
      this.subjectLoading = false
      if (this.$refs.teacherForm) this.$refs.teacherForm.clearValidate()
    },
    teacherFormSnapshot() {
      return JSON.stringify({
        form: this.teacherForm,
        images: this.identityFileList.map((item) => ({ name: item.name || '', url: (item.response && item.response.data && item.response.data.url) || item.url || '' })),
      })
    },
    isTeacherFormDirty() {
      return !!this.teacherFormInitialSnapshot && this.teacherFormSnapshot() !== this.teacherFormInitialSnapshot
    },
    confirmDiscardTeacherForm(close) {
      if (this.teacherSubmitLoading) {
        this.$message.warning('正在保存师资信息，请稍候')
        return
      }
      if (!this.isTeacherFormDirty()) {
        close()
        return
      }
      this.$confirm('当前填写的内容尚未保存，确认关闭弹窗吗？', '放弃本次编辑', {
        confirmButtonText: '确认关闭',
        cancelButtonText: '继续填写',
        type: 'warning',
      }).then(close).catch(() => {})
    },
    beforeCloseTeacherForm(done) {
      this.confirmDiscardTeacherForm(done)
    },
    requestCloseTeacherForm() {
      this.confirmDiscardTeacherForm(() => { this.teacherFormVisible = false })
    },
    validateContactField() {
      if (this.$refs.teacherForm) this.$refs.teacherForm.validateField('teacher_phone')
    },
    scrollToFirstInvalidField(invalidFields) {
      if (!invalidFields || !Object.keys(invalidFields).length) return
      this.$nextTick(() => {
        const form = this.$refs.teacherForm && this.$refs.teacherForm.$el
        const firstInvalid = form && form.querySelector('.el-form-item.is-error')
        if (!firstInvalid) return
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const control = firstInvalid.querySelector('input, textarea')
        if (control) control.focus()
      })
    },
    buildTeacherPayload() {
      const form = this.teacherForm
      const subjectCodes = Array.isArray(form.pre_first_subject_codes) ? form.pre_first_subject_codes : this.splitValues(form.pre_first_subject_codes)
      const payload = {
        teacher_name: form.teacher_name,
        pre_teacher_gender: form.pre_teacher_gender,
        regular_college_code: form.regular_college_code || '',
        regular_college_name: form.regular_college_name || '',
        regular_major_code: form.regular_major_code || '',
        regular_major_name: form.regular_major_name || '',
        tutor_avantage: form.tutor_avantage || '',
        teacher_apply_year: form.teacher_apply_year,
        pre_apply_college_code: form.pre_apply_college_code,
        pre_apply_college_name: form.pre_apply_college_name,
        pre_apply_major_code: form.pre_apply_major_code,
        pre_apply_major_name: form.pre_apply_major_name,
        pre_apply_academy_code: form.pre_apply_academy_code,
        pre_apply_academy_name: form.pre_apply_academy_name,
        pre_apply_direction_code: form.pre_apply_direction_code,
        pre_apply_direction_name: form.pre_apply_direction_name,
        identity_certify_img: this.identityFileList.map((item) => (item.response && item.response.data && item.response.data.url) || item.url).filter(Boolean).join(','),
        pre_first_subject_codes: subjectCodes.join(','),
        pre_first_subject_names: form.pre_first_subject_names || '',
        teacher_phone: form.teacher_phone || '',
        teacher_wechat: form.teacher_wechat || '',
        teacher_qq: form.teacher_qq || '',
        recruit_type: form.recruit_type,
      }
      if (this.editingTeacher) payload.id = form.id
      return payload
    },
    validateTeacherForm() {
      if (this.teacherSubmitLoading) return
      if (this.identityFileList.some((item) => item.status && item.status !== 'success')) {
        this.$message.warning('证明图片正在上传，请稍候再提交')
        return
      }
      this.$refs.teacherForm.validate(async (valid, invalidFields) => {
        if (!valid) {
          this.scrollToFirstInvalidField(invalidFields)
          return
        }
        const isEdit = !!this.editingTeacher
        this.teacherSubmitLoading = true
        try {
          const request = isEdit ? updatePreTeacher : createPreTeacherByHandle
          const res = await request(this.buildTeacherPayload())
          if (res.code !== 0) return
          this.$message.success(isEdit ? '修改成功' : '添加成功')
          this.teacherFormInitialSnapshot = this.teacherFormSnapshot()
          this.teacherFormVisible = false
          await this.refresh()
        } catch (error) {
          // 请求层已统一展示接口错误，这里只负责恢复提交状态。
        } finally {
          this.teacherSubmitLoading = false
        }
      })
    },
    confirmDeleteTeacher(row) {
      this.$confirm(`确认删除师资“${row.teacher_name || ''}”？删除后该师资将不再正常展示。`, '删除师资', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => this.deleteTeacher(row)).catch(() => {})
    },
    async deleteTeacher(row) {
      if (this.deletingTeacherId !== null) return
      this.deletingTeacherId = row.id
      try {
        const res = await updatePreTeacherStatus({ id: row.id, comp_teacher_status: 5 })
        if (res.code !== 0) return
        this.$message.success('删除成功')
        if (this.teacherData.length === 1 && this.teacherPageIndex > 1) this.teacherPageIndex -= 1
        await Promise.all([this.getTeacherList(), this.getCollegeMajorList()])
      } finally {
        this.deletingTeacherId = null
      }
    },
    beforeIdentityUpload(file) {
      const isImage = /^image\//.test(file.type || '')
      const isWithinLimit = file.size / 1024 / 1024 <= 10
      if (!isImage) this.$message.error('只能上传图片格式的证明材料')
      else if (!isWithinLimit) this.$message.error('单张图片不能超过10MB')
      return isImage && isWithinLimit
    },
    identityUploadSuccess(response, file, fileList) {
      const url = Number(response && response.code) === 0 && response.data && response.data.url
      if (!url) {
        this.identityFileList = fileList.filter((item) => item.uid !== file.uid)
        this.$message.error((response && (response.msg || response.error)) || '证明图片上传失败')
        return
      }
      file.url = url
      file.status = 'success'
      this.identityFileList = fileList
    },
    identityUploadError(error, file, fileList) {
      this.identityFileList = fileList.filter((item) => item.uid !== file.uid)
      this.$message.error((error && error.message) || '证明图片上传失败，请稍后重试')
    },
    identityFileChange(file, fileList) {
      this.identityFileList = fileList
    },
    identityFileRemove(file, fileList) {
      this.identityFileList = fileList
    },
    identityUploadExceed() {
      this.$message.warning('最多上传9张证明图片')
    },
    previewIdentityImage(file) {
      const url = (file.response && file.response.data && file.response.data.url) || file.url
      if (!url) return
      this.identityPreviewUrl = url
      this.identityPreviewVisible = true
    },
    regularCollegeChange(code) {
      const selected = this.findByCode(this.collegeOptions, code)
      this.teacherForm.regular_college_name = selected ? selected.name : ''
      this.teacherForm.regular_major_code = ''
      this.teacherForm.regular_major_name = ''
      this.regularMajorOptions = []
      if (code) this.fetchMajorOptions('regular')
    },
    regularMajorChange(code) {
      const selected = this.findByCode(this.regularMajorOptions, code)
      this.teacherForm.regular_major_name = selected ? selected.name : ''
    },
    async confirmClearDependent(message) {
      try {
        await this.$confirm(message, '确认调整录取信息', {
          confirmButtonText: '继续修改',
          cancelButtonText: '取消',
          type: 'warning',
        })
        return true
      } catch (error) {
        return false
      }
    },
    async applyCollegeChange(code) {
      const hasDependentValues = !!(this.teacherForm.pre_apply_major_code || this.teacherForm.pre_apply_academy_code || this.teacherForm.pre_apply_direction_code || this.teacherForm.pre_first_subject_codes.length)
      if (code !== this.previousApplyCollegeCode && hasDependentValues) {
        const confirmed = await this.confirmClearDependent('更换录取院校将清空已选专业、学院、方向和考试科目，是否继续？')
        if (!confirmed) {
          this.teacherForm.pre_apply_college_code = this.previousApplyCollegeCode
          return
        }
      }
      const selected = this.findByCode(this.collegeOptions, code)
      this.teacherForm.pre_apply_college_name = selected ? selected.name : ''
      this.teacherForm.pre_apply_major_code = ''
      this.teacherForm.pre_apply_major_name = ''
      this.applyMajorOptions = []
      this.clearApplyChildren()
      this.previousApplyCollegeCode = code
      this.previousApplyMajorCode = ''
      if (code) this.fetchMajorOptions('apply')
    },
    async applyMajorChange(code) {
      const hasDependentValues = !!(this.teacherForm.pre_apply_academy_code || this.teacherForm.pre_apply_direction_code || this.teacherForm.pre_first_subject_codes.length)
      if (code !== this.previousApplyMajorCode && hasDependentValues) {
        const confirmed = await this.confirmClearDependent('更换录取专业将清空已选学院、方向和考试科目，是否继续？')
        if (!confirmed) {
          this.teacherForm.pre_apply_major_code = this.previousApplyMajorCode
          return
        }
      }
      const selected = this.findByCode(this.applyMajorOptions, code)
      this.teacherForm.pre_apply_major_name = selected ? selected.name : ''
      this.clearApplyChildren()
      this.previousApplyMajorCode = code
      if (code) this.fetchMajorDetail()
    },
    academyChange(code) {
      const selected = this.academyOptions.find((item) => item.academy_code === code)
      this.teacherForm.pre_apply_academy_name = selected ? selected.academy_name : ''
      this.teacherForm.pre_apply_direction_code = ''
      this.teacherForm.pre_apply_direction_name = ''
      this.teacherForm.pre_first_subject_codes = []
      this.teacherForm.pre_first_subject_names = ''
      this.directionOptions = (selected && selected.directions) || []
      this.subjectOptions = []
      if (code) this.fetchSubjectOptions()
    },
    directionChange(code) {
      const selected = this.directionOptions.find((item) => item.direction_code === code)
      this.teacherForm.pre_apply_direction_name = selected ? selected.direction : ''
    },
    subjectChange(codes) {
      this.teacherForm.pre_first_subject_names = codes.map((code) => {
        const item = this.subjectOptions.find((subject) => subject.subject_code === code)
        return item && item.subject_name
      }).filter(Boolean).join(',')
    },
    async fetchMajorOptions(type) {
      const code = type === 'regular' ? this.teacherForm.regular_college_code : this.teacherForm.pre_apply_college_code
      if (!code) return
      if (type === 'regular') this.regularMajorLoading = true
      else this.applyMajorLoading = true
      try {
        const res = await majorlist({ isPaging: 0, college_code: code })
        const list = (res.code === 0 && res.data && res.data.list) || []
        if (type === 'regular') this.regularMajorOptions = list
        else this.applyMajorOptions = list
      } finally {
        if (type === 'regular') this.regularMajorLoading = false
        else this.applyMajorLoading = false
      }
    },
    async fetchMajorDetail() {
      this.majorDetailLoading = true
      try {
        const res = await majorInfo({ college_code: this.teacherForm.pre_apply_college_code, major_code: this.teacherForm.pre_apply_major_code })
        this.academyOptions = (res.code === 0 && res.data && res.data.academys) || []
        const selected = this.academyOptions.find((item) => item.academy_code === this.teacherForm.pre_apply_academy_code)
        this.directionOptions = (selected && selected.directions) || []
      } finally {
        this.majorDetailLoading = false
      }
    },
    async fetchSubjectOptions() {
      this.subjectLoading = true
      try {
        const res = await subjectlist({ isPaging: 0, college_code: this.teacherForm.pre_apply_college_code, academy_code: this.teacherForm.pre_apply_academy_code, major_code: this.teacherForm.pre_apply_major_code })
        this.subjectOptions = (res.code === 0 && res.data && res.data.list) || []
      } finally {
        this.subjectLoading = false
      }
    },
    clearApplyChildren() {
      this.teacherForm.pre_apply_academy_code = ''
      this.teacherForm.pre_apply_academy_name = ''
      this.teacherForm.pre_apply_direction_code = ''
      this.teacherForm.pre_apply_direction_name = ''
      this.teacherForm.pre_first_subject_codes = []
      this.teacherForm.pre_first_subject_names = ''
      this.academyOptions = []
      this.directionOptions = []
      this.subjectOptions = []
    },
    imageFiles(value) { return value ? String(value).split(',').filter(Boolean).map((url, index) => ({ name: `身份证明${index + 1}`, url: url, status: 'success' })) : [] },
    splitValues(value) { return value ? String(value).split(',').map((item) => item.trim()).filter(Boolean) : [] },
    findByCode(list, code) { return list.find((item) => item.code === code) },
    majorOptionLabel(item) { return item ? `(${item.code}) ${item.name}` : '--' },
    directionOptionLabel(item) { return item ? `(${item.direction_code}) ${item.direction}` : '--' },
    subjectOptionLabel(item) { return item ? `（${item.subject_code}）${item.subject_name}` : '--' },
    serialNumber(index, page, size) { return ((page - 1) * size) + index + 1 },
    majorLabel(row) { return row && row.major_name ? `${row.major_code ? `(${row.major_code}) ` : ''}${row.major_name}` : '--' },
    directionLabel(row) { return row && row.pre_apply_direction_name ? `${row.pre_apply_direction_code ? `(${row.pre_apply_direction_code}) ` : ''}${row.pre_apply_direction_name}` : '--' },
    teacherAdvantage(row) { return this.valueOrEmpty(row && (row.tutor_avantage || row.remark)) },
    teacherStatus(row) {
      if (Number(row.comp_teacher_status) === 4 || row.pre_outline_reason || row.pre_remove_reason) return { label: '已下线', type: 'info' }
      if (Number(row.comp_teacher_status) === 2) return { label: '正常', type: 'success' }
      return { label: '审核中', type: 'warning' }
    },
    toggleRemark(id) {
      const index = this.expandedRemarkIds.indexOf(id)
      if (index > -1) this.expandedRemarkIds.splice(index, 1)
      else this.expandedRemarkIds.push(id)
    },
    hasCount(value) { return Number(value) > 0 },
    hasTeacherCount(row) { return this.hasCount(row.count_pre_teacher_normal) || this.hasCount(row.count_pre_teacher_tocheck) || this.hasCount(row.count_pre_teacher_outline) },
    hasContact(row) { return !!(row.teacher_phone || row.teacher_wechat || row.teacher_qq) },
    countValue(value) { return value === 0 || value ? value : '--' },
    scoreLabel(value) { return value === 0 || value ? `${value} 分` : '--' },
    valueOrEmpty(value) { return value === 0 ? 0 : (value || '--') },
    formatTime(value) { return value ? this.$moment(Number(value)).format('YYYY-MM-DD HH:mm') : '--' },
  },
}
</script>

<style lang="less" scoped>
.invitation-senior-page { min-height: 100%; }
.breadcrumb, .page-actions, .table-header, .pagination-wrap, .statistic-list, .drawer-toolbar, .teacher-counts, .invite-link-row { align-items: center; display: flex; }
.breadcrumb, .table-header, .pagination-wrap, .drawer-toolbar { justify-content: space-between; }
.breadcrumb { height: 30px; margin-bottom: 18px; }
.overview-card, .table-card { margin-bottom: 16px; }
.overview-card /deep/ .el-card__body { align-items: center; display: flex; gap: 20px; padding: 14px 20px; }
.page-actions { gap: 8px; }
.overview-statistic { border-right: 1px solid #ebeef5; box-sizing: border-box; flex: 1; min-width: 0; padding-right: 20px; }
.my-invitation { box-sizing: border-box; flex: 0 0 280px; min-width: 0; padding-left: 2px; }
.statistic-list { align-items: stretch; }
.statistic-item { border-right: 1px solid #ebeef5; box-sizing: border-box; flex: 1; min-width: 100px; padding: 0 12px; }
.statistic-item:last-child { border-right: 0; }
.statistic-item span { color: #909399; display: block; font-size: 13px; white-space: nowrap; }
.statistic-item strong { color: #303133; display: block; font-size: 22px; line-height: 30px; }
.statistic-empty-tip { color: #909399; font-size: 12px; line-height: 18px; margin: 7px 12px 0; }
.statistic-empty-tip i { color: #e6a23c; margin-right: 5px; }
.invite-panel-label { color: #606266; font-size: 13px; line-height: 20px; margin-bottom: 8px; }
.invite-panel-label i { color: #409eff; margin-right: 5px; }
.invite-link-row { flex-wrap: nowrap; gap: 8px; }
.invite-link-row .el-button + .el-button { margin-left: 0; }
.invite-tip { color: #909399; font-size: 12px; }
.invite-tip { margin: 5px 0 0; }
.card-title { color: #303133; font-size: 15px; font-weight: 600; }
.card-title span { color: #909399; font-size: 13px; font-weight: normal; }
.table-header { margin-bottom: 14px; }
.college-major-search { width: 340px; }
.college-table { width: 100%; }
.teacher-counts { gap: 7px; justify-content: center; }
.empty-value { color: #909399; }
.count-item { border-radius: 12px; font-size: 12px; line-height: 24px; padding: 0 9px; white-space: nowrap; }
.count-item strong { font-size: 13px; }
.count-item.normal { background: #edf8f2; color: #40936c; }
.count-item.checking { background: #fff7e8; color: #b98120; }
.count-item.offline { background: #f4f4f5; color: #7b7d82; }
.pagination-wrap { color: #909399; font-size: 13px; margin-top: 16px; }
.table-empty { color: #909399; padding: 32px 0; }
.table-empty i { font-size: 38px; }
.table-empty p { margin: 8px 0 12px; }
.teacher-drawer-content { box-sizing: border-box; padding: 0 22px 24px; }
/deep/ .el-drawer__header { color: #303133; font-size: 17px; margin-bottom: 18px; overflow: hidden; padding: 20px 22px 0; }
/deep/ .el-drawer__header > span { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.drawer-toolbar { background: #f7f9fc; border: 1px solid #ebeef5; border-radius: 4px; color: #909399; font-size: 13px; margin-bottom: 14px; padding: 10px 12px; }
.teacher-main { align-items: center; display: flex; flex-wrap: wrap; gap: 7px; justify-content: center; }
.teacher-main strong { color: #303133; font-size: 14px; }
.teacher-main small { color: #909399; flex-basis: 100%; }
.cell-lines { text-align: left; }
.cell-lines p { color: #606266; line-height: 20px; margin: 2px 0; word-break: break-all; }
.cell-lines p span { color: #909399; display: inline-block; margin-right: 8px; width: 34px; }
.cell-lines.compact p span { width: 30px; }
.contact-lines { text-align: left; }
.contact-line { align-items: center; display: flex; line-height: 22px; min-width: 0; }
.contact-line > span { color: #909399; flex: 0 0 34px; }
.contact-line > em { color: #606266; flex: 1; font-style: normal; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.contact-line .el-button { flex: 0 0 auto; margin-left: 6px; padding: 3px 0; }
.teacher-remark { -webkit-box-orient: vertical; -webkit-line-clamp: 2; display: -webkit-box; line-height: 20px; overflow: hidden; text-align: left; white-space: pre-line; word-break: break-word; }
.teacher-remark.expanded { -webkit-line-clamp: initial; }
.remark-toggle { display: block; margin-top: 4px; text-align: right; }
.delete-action { color: #f56c6c; margin-left: 12px; padding: 3px 0; }
.drawer-pagination { margin-bottom: 4px; }
.material-actions { border-bottom: 1px solid #ebeef5; display: flex; gap: 8px; padding-bottom: 14px; }
.material-placeholder { color: #909399; padding: 50px 0; text-align: center; width: 100%; }
.material-placeholder.initial { min-height: 180px; }
.material-placeholder i { color: #c0c4cc; font-size: 48px; }
.material-placeholder p { color: #606266; font-size: 15px; margin: 14px 0 0; }
.qr-material { align-items: center; display: flex; justify-content: center; min-height: 280px; }
.invite-qrcode { display: block; max-height: 360px; max-width: 100%; object-fit: contain; }
.poster-material { align-items: flex-start; display: flex; justify-content: center; max-height: 620px; min-height: 320px; overflow: auto; padding: 16px 0; }
.invite-poster { display: block; max-width: 68%; width: 320px; }
.qrcode-renderer { left: -9999px; position: fixed; top: -9999px; }
.teacher-dialog-heading { min-width: 0; padding-right: 34px; }
.teacher-dialog-title-row { align-items: center; display: flex; gap: 10px; }
.teacher-dialog-title-row strong { color: #303133; font-size: 18px; line-height: 26px; }
.teacher-dialog-context { color: #909399; font-size: 13px; line-height: 20px; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.teacher-dialog-context i { color: #409eff; margin-right: 5px; }
/deep/ .teacher-form-dialog { display: flex; flex-direction: column; margin-bottom: 0; max-height: 90vh; max-width: calc(100vw - 24px); overflow: hidden; }
/deep/ .teacher-form-dialog .el-dialog__header { border-bottom: 1px solid #ebeef5; flex: 0 0 auto; padding: 18px 22px 14px; }
/deep/ .teacher-form-dialog .el-dialog__headerbtn { top: 20px; }
/deep/ .teacher-form-dialog .el-dialog__body { background: #f5f7fa; flex: 1; min-height: 0; overflow-y: auto; padding: 18px 20px; }
/deep/ .teacher-form-dialog .el-dialog__footer { background: #fff; border-top: 1px solid #ebeef5; flex: 0 0 auto; padding: 13px 20px; }
.teacher-form-layout { align-items: start; display: grid; gap: 16px; grid-template-columns: minmax(0, 1fr) 300px; }
.teacher-form-main { display: grid; gap: 14px; min-width: 0; }
.teacher-form-aside { align-self: start; display: grid; gap: 14px; min-width: 0; position: sticky; top: 0; }
.form-section-card { background: #fff; border: 1px solid #e4e7ed; border-radius: 8px; box-shadow: 0 1px 2px rgba(31, 45, 61, 0.03); padding: 16px 18px 2px; }
.form-section-card:hover { border-color: #d9e2f1; }
.form-section-heading { align-items: center; display: flex; gap: 8px; margin-bottom: 13px; }
.form-section-heading span { color: #303133; font-size: 15px; font-weight: 600; }
.form-section-heading span::before { background: #409eff; border-radius: 2px; content: ''; display: inline-block; height: 14px; margin-right: 8px; vertical-align: -2px; width: 3px; }
.form-section-heading small { color: #909399; font-size: 12px; font-weight: normal; }
.form-grid { display: grid; gap: 0 18px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
.form-grid .full { grid-column: 1 / -1; }
.teacher-form .el-select, .teacher-form .el-input { width: 100%; }
.teacher-form /deep/ .el-form-item { margin-bottom: 17px; }
.teacher-form /deep/ .el-form-item__label { color: #606266; font-weight: 500; line-height: 22px; padding-bottom: 6px; }
.teacher-form /deep/ .el-radio-group { align-items: center; display: flex; height: 32px; }
.teacher-form /deep/ .el-input__inner, .teacher-form /deep/ .el-textarea__inner { border-color: #dcdfe6; }
.teacher-form /deep/ .el-input__inner:focus, .teacher-form /deep/ .el-textarea__inner:focus { border-color: #409eff; }
.optional-section, .advantage-section { border-color: #ebeef5; }
.no-bottom-margin { margin-bottom: 14px !important; }
.contact-section { padding-bottom: 3px; }
.contact-section .form-section-heading { align-items: flex-start; flex-direction: column; gap: 3px; }
.contact-section .form-section-heading small { padding-left: 11px; }
.identity-section { padding-bottom: 16px; }
.identity-uploader { line-height: 0; }
.identity-uploader /deep/ .el-upload--picture-card, .identity-uploader /deep/ .el-upload-list--picture-card .el-upload-list__item { height: 76px; line-height: 74px; margin: 0 8px 8px 0; width: 76px; }
.identity-uploader /deep/ .el-upload--picture-card { background: #fafafa; border-color: #d9dfe8; }
.identity-uploader /deep/ .el-upload--picture-card:hover { background: #f0f7ff; border-color: #409eff; }
.identity-uploader /deep/ .el-upload--picture-card i { font-size: 22px; }
.form-help { color: #909399; font-size: 12px; line-height: 19px; margin-top: 3px; }
.teacher-form-footer { align-items: center; display: flex; justify-content: space-between; }
.form-completion { align-items: center; color: #909399; display: flex; font-size: 12px; gap: 9px; }
.form-completion .el-progress { width: 118px; }
.form-completion strong { color: #606266; font-weight: 500; }
.identity-preview-image { display: block; margin: 0 auto; max-height: 68vh; max-width: 100%; object-fit: contain; }
/deep/ .identity-preview-dialog .el-dialog__body { padding: 16px 20px 24px; text-align: center; }
@media screen and (max-width: 1280px) {
  .overview-card /deep/ .el-card__body { display: block; }
  .overview-statistic { border-bottom: 1px solid #ebeef5; border-right: 0; margin-bottom: 12px; padding: 0 0 12px; }
  .my-invitation { width: 100%; }
  .statistic-list { flex-wrap: wrap; }
  .statistic-item { flex-basis: 33.3%; margin: 6px 0; }
}
@media screen and (max-width: 980px) {
  .teacher-form-layout { grid-template-columns: 1fr; }
  .teacher-form-aside { position: static; }
}
@media screen and (max-width: 760px) {
  .breadcrumb { align-items: flex-start; height: auto; }
  .page-actions { flex-shrink: 0; }
  .table-header { align-items: flex-start; flex-direction: column; gap: 10px; }
  .college-major-search { width: 100%; }
  .invite-link-row { align-items: flex-start; }
  .form-grid { grid-template-columns: 1fr; }
  .form-grid .full { grid-column: auto; }
  .teacher-form-footer { align-items: flex-end; gap: 12px; }
  .form-completion .el-progress { width: 72px; }
}
</style>
